import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ScrollService {
    private isScrollLocked = false;

    constructor() {}

    lockScroll() {
        if (!this.isScrollLocked) {
            document.body.style.overflow = 'hidden';
            this.isScrollLocked = true;
        }
    }

    unlockScroll() {
        if (this.isScrollLocked) {
            document.body.style.overflow = '';
            this.isScrollLocked = false;
        }
    }

    toggleScroll() {
        this.isScrollLocked ? this.unlockScroll() : this.lockScroll();
    }
}
